import { render, staticRenderFns } from "./HotBlockList.vue?vue&type=template&id=bd5f57ee"
import script from "./HotBlockList.vue?vue&type=script&lang=ts"
export * from "./HotBlockList.vue?vue&type=script&lang=ts"
import style0 from "./HotBlockList.vue?vue&type=style&index=0&id=bd5f57ee&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports